<template>
    <div class="flex flex-wrap items-center">
        <div
            v-for="(item, index) in data"
            :key="index"
            :class="[twMerge('w-full', item.class), item.type === 'Column' ? '' : 'my-3 first:mt-0 last:mb-0']"
        >
            <div v-if="item.type === 'Column'">
                <UtilsFormBuilder :form-size="formSize" :data="item.data.props" v-model="model" />
            </div>
            <UFormGroup
                v-else
                :key="index"
                :label="item.data.label"
                :size="formSize"
                :name="formGroupName(item.data.name)"
                :ui="formGroupUi"
                :required="item.required"
                v-bind="item.data.formProps"
            >
                <USelectMenu v-if="item.type === 'SelectMenu'" v-model="model[item.data.name]" v-bind="item.data.props">
                    <template v-for="el in item.data.slots" #[el.key]="itemProps">
                        <component :is="el.content" :data="itemProps" :value="model[item.data.name]" />
                    </template>
                </USelectMenu>
                <UInput v-else-if="item.type === 'Input'" v-model="model[item.data.name]" v-bind="item.data.props" />
                <UiComponentPasswordInput
                    v-else-if="item.type === 'Password'"
                    v-model="model[item.data.name]"
                    :options="item.data.props"
                />
                <div v-else-if="item.type === 'Range'">
                    <URange v-model="model[item.data.name]" v-bind="item.data.props" />
                    <slot :name="`range-${index}`" :value="model[item.data.name]" :data="item.data"></slot>
                </div>
                <UTextarea
                    v-else-if="item.type === 'TextArea'"
                    v-model="model[item.data.name]"
                    v-bind="item.data.props"
                />
                <UtilsSolarDatePicker
                    v-else-if="item.type === 'DatePicker'"
                    v-model="model[item.data.name]"
                    :size="formSize"
                    v-bind="item.data.props"
                />
            </UFormGroup>
        </div>
    </div>
</template>

<script setup lang="ts">
import { twMerge } from "tailwind-merge";
import type { ModelRef, PropType } from "vue";
import type { IForm } from "~/libs/types/general";

interface ItemDataProps {
    [key: string]: any;
}

const props = defineProps({
    index: Number,
    data: Array as PropType<IForm<any>[]>,
    formSize: {
        type: String as PropType<"2xs" | "xs" | "sm" | "md" | "lg" | "xl">,
        default: "sm",
    },
});

const model: ModelRef<ItemDataProps> = defineModel({ required: true });

const formGroupUi = {
    error: "absolute top-full right-0 mt-0.5 mx-1 text-rose-500 dark:text-rose-400",
    label: {
        required: "after:text-rose-500 dark:after:text-rose-400",
    },
};

function formGroupName(name: string) {
    return isUndefined(props.index) ? name : `[${props.index}].${name}`;
}
</script>
